// hooks/useTokenData.ts
import { useEffect } from "react";
import { useCatDev } from "@/context/catdevContext";
import { toast } from "sonner";

export const useFetchTokenData = () => {
  const {
    tokenData,
    setTokenData,
    votingData,
    setVotingData,
    isVotes,
    setIsVotes,
    parentDetails,
    setParentDetails,
    isLoading,
    setIsLoading,
  } = useCatDev();

  useEffect(() => {
    if (tokenData.length > 0) return; // if already fetched

    setIsLoading(true);
    const fetchData = async () => {
      try {
        const res = await fetch("https://api.catdevai.com/api/token-data/");
        const data = await res.json();

        if (res.ok && data.data.length > 0) {
          setVotingData(data.voting_data);
          setTokenData(data.data[0].data);
          setParentDetails(data.data[0].parent_details);
          setIsVotes(data.is_votes);
        }
        setIsLoading(false);
      } catch (error) {
        toast.error(
          `Error fetching token data: ${
            error instanceof Error ? error.message : error
          }`
        );
        setIsLoading(false);
      }
    };

    fetchData();
  }, [tokenData, setTokenData, setVotingData, setParentDetails, setIsVotes, setIsLoading]);

  return { tokenData, votingData, isVotes, parentDetails, isLoading };
};
